import { render } from "./ExcludedUsersModal.vue?vue&type=template&id=1066d606&scoped=true"
import script from "./ExcludedUsersModal.vue?vue&type=script&lang=js"
export * from "./ExcludedUsersModal.vue?vue&type=script&lang=js"

import "./ExcludedUsersModal.vue?vue&type=style&index=0&id=1066d606&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1066d606"]])

export default __exports__